import React, { useMemo } from "react";

import {
  ArrowContainer,
  Circle,
  LineContainer,
  ProgressContainer,
  ProgressDots,
  ProgressFill,
  useStyles,
} from "./styles";

const ArrowRight = require("../../../../../assets/img/ArrowProgress.svg");

interface LinearProgressProps {
  percentage: number;
  id?: string;
}

export const LinearProgress = ({ id, percentage }: LinearProgressProps) => {
  const hasStarted = useMemo(() => percentage > 0, [percentage]);
  const hasFinished = useMemo(() => percentage === 100, [percentage]);
  const classes = useStyles();

  return (
    <ProgressContainer id={id}>
      <LineContainer percentage={percentage}>
        <Circle filled={hasStarted} className={classes.initialCircle} />
        <ProgressFill percentage={percentage} />
        {percentage <= 99 && <ProgressDots />}
        {percentage !== 100 ? (
          <ArrowContainer percentage={percentage <= 97 ? percentage : 97}>
            <img src={ArrowRight} className={classes.progressArrow} />
          </ArrowContainer>
        ) : null}
        <Circle filled={hasFinished} className={classes.endCircle} />
      </LineContainer>
    </ProgressContainer>
  );
};
